import { FooterNavigator } from '../Footer/FooterNavigator';

import { FooterNavigatorProps } from '../Footer/types';

export const Confirm = ({
  betweenButtons,
  footerNavigatorClassName = '',
  disabledButtons = false,
  saveButtonMane,
  saveButtonVariant,
  subtitle,
  svg,
  title,
  onCancel,
  onSave,
}: {
  betweenButtons?: JSX.Element;
  footerNavigatorClassName?: string;
  disabledButtons?: boolean;
  saveButtonMane?: FooterNavigatorProps['saveButtonName'];
  saveButtonVariant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'negative'
    | 'transparent';
  subtitle: string;
  svg?: JSX.Element;
  title: string;
  onCancel?(): void;
  onSave(): void;
}) => (
  <div className="flex flex-col h-full gap-4 m-8 justify-center">
    <span className="flex items-center mx-auto">{svg}</span>
    <div
      className={`
          w-4/5
          mx-auto
          font-medium
          text-center
          text-xl
          text-black
          dark:text-white
        `}
    >
      {title}
    </div>

    <div className="text-grey-50 w-4/5 mx-auto text-center">{subtitle}</div>

    <FooterNavigator
      betweenButtons={betweenButtons}
      className={footerNavigatorClassName}
      isDisabledCancelButton={disabledButtons}
      isDisabledSaveButton={disabledButtons}
      saveButtonName={saveButtonMane}
      saveButtonVariant={saveButtonVariant}
      onCancel={onCancel}
      oneButton={!onCancel}
      onSave={onSave}
    />
  </div>
);
